import styled from 'styled-components';
import { getSkillLevel, getSkillLevelRequiredXp, SkillProps } from '../../services/skill';
import Icon from '../../ui/Icon';
import ProgressCircular from '../../ui/Progress/PorgressCircular';
import Tooltip from '../../ui/Tooltip/Tooltip';

interface Props {
    skill: SkillProps;
}

export default function Skill({ skill }: Props) {
    const currentLevel = getSkillLevel(skill.xpTotal);
    const currentLevelXp = skill.xpTotal - getSkillLevelRequiredXp(currentLevel);
    const currentLevelXpNeeded = getSkillLevelRequiredXp(currentLevel + 1) - getSkillLevelRequiredXp(currentLevel)
    return (
        <Wrapper>
            <div className='skill-name'>{skill.name}</div>

            <Tooltip anchorPosition={{ x: 'right', y: 'center' }} originPosition={{ x: 'left', y: 'center' }} content={<div >Total XP: {skill.xpTotal.toFixed(1)}</div>}>
                <div className='skill-progress-container'>
                    <ProgressCircular value={(currentLevelXp / currentLevelXpNeeded) * 100} thickness={1} size={80} className='skill-progress'></ProgressCircular>
                    <div className='skill-progress-body'>
                        <Icon className='skill-icon' icon={skill.icon} size={28}></Icon>
                        <div className='skill-lvl'>Lvl. {currentLevel}</div>
                    </div>

                </div>
            </Tooltip>

            {/* <div className='skill-lvl'>Lvl. {currentLevel}</div> */}

            <div className='skill-xp'>{currentLevelXp.toFixed(1)} / {currentLevelXpNeeded.toFixed(1)}</div>

        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0px;
    padding: 14px;
    background-color: ${props => props.theme.backgroundColor};
    border-radius: ${props => props.theme.borderRadius};

    .skill-icon {
        /* padding-bottom: 16px; */
    }

    .skill-name {
        text-align: center;
        font-size: 12px;
        color: #cccccc;
    }

    .skill-lvl {
        margin-top: 4px;
        font-size: 13px;
        /* color: #dddddd; */
    }

    .skill-xp {
        margin-top: 4px;
        text-align: center;
        font-size: 11px;
        color: #cccccc;
    }

    .skill-progress-container {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;
        /* width: 80px;
        height: 80px; */
        margin: 10px;
    }

    .skill-progress-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .skill-progress-body, .skill-progress {
        grid-area: 1/1;
    }
`